"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveCollaboratorDialog = void 0;
var _resourceShareCopy = require("./resource-share-copy");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _jsxRuntime = require("react/jsx-runtime");
var RemoveCollaboratorDialog = exports.RemoveCollaboratorDialog = function RemoveCollaboratorDialog(_ref) {
  var collaborator = _ref.collaborator,
    error = _ref.error,
    resourceName = _ref.resourceName,
    resourceKind = _ref.resourceKind,
    isRemoving = _ref.isRemoving,
    focusFallbackRef = _ref.focusFallbackRef,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
    tone: "destructive",
    title: "Remove collaborator",
    message: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: (0, _resourceShareCopy.removeCollaboratorQuestion)(collaborator, resourceName, resourceKind)
      }), error ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        role: "alert",
        className: "text-sm text-destructive",
        children: error
      }) : null]
    }),
    confirmLabel: "Remove",
    cancelLabel: "Cancel",
    confirmDisabled: isRemoving,
    focusFallbackRef: focusFallbackRef,
    onCancel: onCancel,
    onConfirm: onConfirm,
    "data-sentry-element": "ConfirmationDialog",
    "data-sentry-component": "RemoveCollaboratorDialog",
    "data-sentry-source-file": "remove-collaborator-dialog.tsx"
  });
};